export default __webpack_public_path__ + "static/media/logo.a50f8d87.svg";